import { useState } from "react";
import { GrUpload, GrDocument } from "react-icons/gr";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import "./initiator.css";
import Header from "../../components/header/Header";
import Preloader from "../../components/preloader/Preloader";
import InitiatorService from "../../services/initiator.service";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

const Initiator = () => {
	const { user } = useContext(AuthContext);
	const [submitting, setSubmitting] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);
	const [loading, setLoading] = useState(false);
	const [bidLoading, setBidLoading] = useState(false);
	const [execFileLoading, setExecFileLoading] = useState(false);
	const [signedOfferLoading, setSignedOfferLoading] = useState(false);
	const [verificationDocLoading, setVerificationDocLoading] = useState(false);
	const [projectImage, setProjectImage] = useState(null);
	const [bidFile, setBidFile] = useState(null);
	const [execSummary, setExecSummary] = useState(null);
	const [signedOffer, setSignedOffer] = useState(null);
	const [verificationDoc, setVerificationDoc] = useState(null);
	const [pPmode, setPpMode] = useState("");
	const [accountTitle, setAccountTitle] = useState("");
	const [bankName, setBankName] = useState("");
	const [accountNum, setAccountNum] = useState("");

	const projectImageUploadHandler = async (e) => {
		e.preventDefault();
		const _projectImg = e.target.files[0];
		setLoading(true);

		if (_projectImg) {
			setInterval(() => {
				setProjectImage(_projectImg);
				setLoading(false);
			}, 2000);
		}
	};

	const projectBidUploadHandler = async (e) => {
		e.preventDefault();
		const _projectBid = e.target.files[0];
		setBidLoading(true);

		if (_projectBid) {
			setInterval(() => {
				setBidFile(_projectBid);
				setBidLoading(false);
			}, 2000);
		}
	};

	const projectExecSumUploadHandler = async (e) => {
		e.preventDefault();
		let _execSummary = e.target.files[0];
		setExecFileLoading(true);
		if (_execSummary) {
			setInterval(() => {
				setExecSummary(_execSummary);
				setExecFileLoading(false);
			}, 2000);
		}
	};

	const projectSignedOfferUploadHandler = async (e) => {
		e.preventDefault();
		let _signedOffer = e.target.files[0];
		setSignedOfferLoading(true);
		if (_signedOffer) {
			setInterval(() => {
				setSignedOffer(_signedOffer);
				setSignedOfferLoading(false);
			}, 2000);
		}
	};

	const verificationDocUploadHandler = async (e) => {
		e.preventDefault();
		let _verificationDoc = e.target.files[0];
		setVerificationDocLoading(true);
		if (_verificationDoc) {
			setInterval(() => {
				setVerificationDoc(_verificationDoc);
				setVerificationDocLoading(false);
			}, 2000);
		}
	};

	const [projectTitle, setProjectTitle] = useState("");
	const [projectLocation, setProjectLocation] = useState("");
	const [projectPurpose, setProjectPurpose] = useState("");
	const [projectTenor, setProjectTenor] = useState("");
	const [projectPartialAmount, setProjectPartialAmount] = useState("");
	const [projectFullAmount, setProjectFullAmount] = useState("");
	const [companyName, setCompanyName] = useState("");
	const [companyWebsite, setCompanyWebsite] = useState("");
	const [companySummary, setCompanySummary] = useState("");
	const [show, setShow] = useState(false);

	const handleClose = (e) => {
		e.preventDefault();
		setShow(false);
	};

	const handleShow = (e) => {
		e.preventDefault();
		setShow(true);
	};

	const handleSelectTenor = (e) => setProjectTenor(e.target.value);

	const handleSelectedPurpose = (e) => setProjectPurpose(e.target.value);

	const createProject = async (e) => {
		e.preventDefault();

		const _projectData = new FormData();

		_projectData.append("title", projectTitle);
		_projectData.append("location", projectLocation);
		_projectData.append("image", projectImage);
		_projectData.append("purpose", projectPurpose);
		_projectData.append("tenor", projectTenor);
		_projectData.append("partialAmount", projectPartialAmount);
		_projectData.append("fullAmount", projectFullAmount);
		_projectData.append("companyName", companyName);
		_projectData.append("companyWebsite", companyWebsite);
		_projectData.append("companySummary", companySummary);
		_projectData.append("bidFile", bidFile);
		_projectData.append("executiveSummary", execSummary);
		_projectData.append("offerDocument", signedOffer);
		_projectData.append("verificationDocument", verificationDoc);
		_projectData.append("preferredModeOFPayment", pPmode);
		_projectData.append("titleOfAccount", accountTitle);
		_projectData.append("bankName", bankName);
		_projectData.append("bankAccountNumber", accountNum);

		setSubmitting(true);
		setIsDisabled(true);
		await InitiatorService.initiateProject(_projectData);
		setSubmitting(false);
		setIsDisabled(false);
		clearForm();
	};

	const clearForm = () => {
		setProjectTitle("");
		setProjectLocation("");
		setProjectPurpose("");
		setProjectTenor("");
		setProjectPartialAmount("");
		setProjectFullAmount("");
		setCompanyName("");
		setCompanyWebsite("");
		setCompanySummary("");
		setProjectImage(null);
		setBidFile(null);
		setExecSummary(null);
		setSignedOffer(null);
		setVerificationDoc(null);
		setPpMode("");
		setAccountTitle("");
		setBankName("");
		setAccountNum("");
	};

	return (
		<div className="action__page">
			<Header />
			<div className="initiator__page__heading">INITIATOR DESK</div>
			<form className="initiator__page">
				<div className="card-wrapper">
					<div className="card-container">
						<label className="card--header">PROJECT TITLE</label>
						<div className="card">
							<input
								required
								className="card-heading project-title"
								type="text"
								placeholder="Input Title e.g, Kubwa High School"
								onChange={(e) => setProjectTitle(e.target.value)}
							/>
							<input
								required
								className="card-heading project-title"
								type="text"
								placeholder="Input Location e.g, Kubwa, Abuja"
								onChange={(e) => setProjectLocation(e.target.value)}
							/>
							{projectImage ? (
								<div className="project__image-holder">
									<div className="project__image-uploader__button">
										<GrDocument />
									</div>
									<input
										required
										type="text"
										className="project__image-uploader"
										name="project-image"
										readOnly
										value={projectImage.name}
									/>
									<span>{projectImage.name.substring(0, 10)}...</span>
								</div>
							) : loading ? (
								<div className="loading-info">
									<Spinner animation="border" role="status" variant="info" />
									<span>loading...</span>
								</div>
							) : (
								<label htmlFor="uploader">
									<input
										required
										type="file"
										id="uploader"
										name="file"
										className="project__image-uploader"
										accept=".png, .jpg, .jpeg"
										onChange={projectImageUploadHandler}
									/>
									<div className="project__image-holder">
										<div className="project__image-uploader__button">
											<GrUpload />
										</div>
										<span>Click arrow to upload project image</span>
									</div>
								</label>
							)}
						</div>
					</div>

					<div className="card-container">
						<div className="card--header">PURPOSE OF PROJECT</div>
						<div className="card">
							<div className="initiator__project-purpose">
								<div className="project-purpose card__radio-btn">
									<Form.Check.Input
										onChange={handleSelectedPurpose}
										checked={projectPurpose === "New School Building"}
										value="New School Building"
										type="radio" 
										required
									/>
									<Form.Check.Label>New School Building</Form.Check.Label>
								</div>
								<div className="project-purpose card__radio-btn">
									<Form.Check.Input
										onChange={handleSelectedPurpose}
										checked={projectPurpose === "School Renovation"}
										value="School Renovation"
										type="radio" 
										required
									/>
									<Form.Check.Label>School Renovation</Form.Check.Label>
								</div>
								<div className="project-purpose card__radio-btn">
									<Form.Check.Input
										onChange={handleSelectedPurpose}
										checked={projectPurpose === "Purchase of Equipment"}
										value="Purchase of Equipment"
										type="radio" 
										required
									/>
									<Form.Check.Label>Purchase of Equipment </Form.Check.Label>
								</div>
								<div className="project-purpose card__radio-btn">
									<Form.Check.Input
										onChange={handleSelectedPurpose}
										checked={projectPurpose === "Others"}
										value="Others"
										type="radio" 
										required
									/>
									<Form.Check.Label>Others</Form.Check.Label>
								</div>
							</div>
						</div>
					</div>

					<div className="card-container">
						<div className="card--header">PROJECT TENOR</div>
						<div className="card">
							<div className="card-inside card__radio">
								<div className="card-info card__radio-btn">
									<Form.Check.Input
										onChange={handleSelectTenor}
										checked={projectTenor === "2"}
										value="2"
										type="radio" 
										required
									/>
									<Form.Check.Label>2 Years</Form.Check.Label>
								</div>
								<div className="card-info card__radio-btn">
									<Form.Check.Input
										onChange={handleSelectTenor}
										checked={projectTenor === "4"}
										value="4"
										type="radio" 
										required
									/>
									<Form.Check.Label>4 Years</Form.Check.Label>
								</div>
								<div className="card-info card__radio-btn">
									<Form.Check.Input
										onChange={handleSelectTenor}
										checked={projectTenor === "6"}
										value="6"
										type="radio" 
										required
									/>
									<Form.Check.Label>6 Years</Form.Check.Label>
								</div>
								<div className="card-info card__radio-btn">
									<Form.Check.Input
										onChange={handleSelectTenor}
										checked={projectTenor === "8"}
										value="8"
										type="radio" 
										required
									/>
									<Form.Check.Label>8 Years</Form.Check.Label>
								</div>
								<div className="card-info card__radio-btn">
									<Form.Check.Input
										onChange={handleSelectTenor}
										checked={projectTenor === "10"}
										value="10"
										type="radio" 
										required
									/>
									<Form.Check.Label>10 Years</Form.Check.Label>
								</div>
								<div className="card-info card__radio-btn">
									<Form.Check.Input
										onChange={handleSelectTenor}
										checked={projectTenor === "12"}
										value="12"
										type="radio" 
										required
									/>
									<Form.Check.Label>12 Years</Form.Check.Label>
								</div>
							</div>
							<span className="card__radio-span">
								Click circle to select project tenor
							</span>
						</div>
					</div>

					<div className="card-container">
						<div className="card--header">PROJECT AMOUNT</div>
						<div className="card card__project-amount">
							<label
								htmlFor="partial-amount-provision partial"
								className="partial-payment"
							>
								PARTIAL PAYMENT PROVISION:
							</label>
							<div className="input-holder" style={{ marginBottom: "10px" }}>
								<span>&#x20A6;</span>{" "}
								<input
									required
									type="number"
									id="partial-amount-provision"
									name="partial-amount-provision"
									placeholder="0.00"
									onChange={(e) => setProjectPartialAmount(e.target.value)}
								/>
							</div>

							<label htmlFor="full-amount-provision" className="full-payment">
								FULL PAYMENT PROVISION:
							</label>
							<div className="input-holder">
								<span>&#x20A6;</span>{" "}
								<input
									required
									type="number"
									id="full-amount-provision"
									name="full-amount-provision"
									placeholder="0.00"
									onChange={(e) => setProjectFullAmount(e.target.value)}
								/>
							</div>
							<button className="bank__button" onClick={handleShow}>
								Upload BANK Details
							</button>
						</div>
					</div>
					<div className="card-container">
						<div className="card--header">PROJECT CONTRACTOR</div>
						<div className="card card__project-amount">
							<div className="input-holder company-form company__input-holder">
								<input
									required
									type="text"
									id="partial-amount-provision"
									name="partial-amount-provision"
									placeholder="Input company name..."
									onChange={(e) => setCompanyName(e.target.value)}
								/>
							</div>
							<div className="input-holder company-form company__input-holder">
								<input
									required
									type="text"
									id="full-amount-provision"
									name="full-amount-provision"
									placeholder="Input company website..."
									onChange={(e) => setCompanyWebsite(e.target.value)}
								/>
							</div>
							<div className="company__input-holder">
								<textarea
									onChange={(e) => setCompanySummary(e.target.value)}
									placeholder="Company summary..."
									required
								></textarea>
							</div>
						</div>
					</div>

					<div className="card-container">
						<div className="card--header">DOCUMENTS UPLOAD</div>
						<div className="card">
							<div className="doc__upload-area">
								{bidFile ? (
									<div className="uploaded__file" style={{ marginBottom: "15px" }}>
										<GrDocument className="the__file" />
										<input
											required
											type="text"
											readOnly
											value={bidFile.name}
											className="uploaded__file-input"
										/>
										<span>{bidFile.name.substring(0, 10)}...</span>
									</div>
								) : bidLoading ? (
									<div className="loading-info">
										<Spinner animation="border" role="status" variant="info" />
										<span>loading...</span>
									</div>
								) : (
									<label className="doc__upload-area__div">
										<input
											required
											type="file"
											name="file"
											accept=".pdf"
											className="doc__upload-btn"
											onChange={projectBidUploadHandler}
										/>
										<div className="file__upload-btn">Upload Bid</div>
									</label>
								)}

								{execSummary ? (
									<div className="uploaded__file" style={{ marginBottom: "15px" }}>
										<GrDocument className="the__file" />
										<input
											required
											type="text"
											readOnly
											value={execSummary.name}
											className="uploaded__file-input"
										/>
										<span>{execSummary.name.substring(0, 10)}...</span>
									</div>
								) : execFileLoading ? (
									<div className="loading-info">
										<Spinner animation="border" role="status" variant="info" />
										<span>loading...</span>
									</div>
								) : (
									<label className="doc__upload-area__div">
										<input
											required
											type="file"
											name="file"
											accept=".pdf"
											className="doc__upload-btn"
											onChange={projectExecSumUploadHandler}
										/>
										<div className="file__upload-btn">Upload Executive Summary</div>
									</label>
								)}

								{signedOffer ? (
									<div className="uploaded__file" style={{ marginBottom: "15px" }}>
										<GrDocument className="the__file" />
										<input
											required
											type="text"
											readOnly
											value={signedOffer.name}
											className="uploaded__file-input"
										/>
										<span>{signedOffer.name.substring(0, 10)}...</span>
									</div>
								) : signedOfferLoading ? (
									<div className="loading-info">
										<Spinner animation="border" role="status" variant="info" />
										<span>loading...</span>
									</div>
								) : (
									<label className="doc__upload-area__div">
										<input
											required
											type="file"
											name="file"
											accept=".pdf"
											className="doc__upload-btn"
											onChange={projectSignedOfferUploadHandler}
										/>
										<div className="file__upload-btn"> Upload Signed Offer</div>
									</label>
								)}

								{verificationDoc ? (
									<div className="uploaded__file" style={{ marginBottom: "15px" }}>
										<GrDocument className="the__file" />
										<input
											required
											type="text"
											readOnly
											value={verificationDoc.name}
											className="uploaded__file-input"
										/>
										<span>{verificationDoc.name.substring(0, 10)}...</span>
									</div>
								) : verificationDocLoading ? (
									<div className="loading-info">
										<Spinner animation="border" role="status" variant="info" />
										<span>loading...</span>
									</div>
								) : (
									<label className="doc__upload-area__div">
										<input
											required
											type="file"
											name="file"
											accept=".pdf"
											className="doc__upload-btn"
											onChange={verificationDocUploadHandler}
										/>
										<div className="file__upload-btn">Upload Verification Documents</div>
									</label>
								)}
							</div>
						</div>
					</div>
					<p className="initiator__note-info">N.B. KINDLY REVIEW BEFORE APPROVING</p>
				</div>
				<div className="initiator__action-btns">
					<button onClick={() => clearForm()}>CANCEL</button>
					<button onClick={createProject} disabled={isDisabled}>
						SUBMIT
					</button>
				</div>
				<p className="initiator__id">
					UPLOADED BY {user.lastname.toUpperCase()} {user.firstname.toUpperCase()}{" "}
					{user.staffnum.toUpperCase()}
				</p>
			</form>
			<Modal show={show} onHide={handleClose}>
				<Modal.Header>
					<Modal.Title>Company Account Details</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="bank_form">
						<label htmlFor="full-amount-provision" className="full-payment">
							MODE OF PAYMENT:
						</label>
						<div className="input-holder company__input-holder">
							<input
								required
								type="text"
								id="full-amount-provision"
								name="full-amount-provision"
								placeholder="Input prefered mode of payment"
								onChange={(e) => setPpMode(e.target.value)}
							/>
						</div>
						<label htmlFor="full-amount-provision" className="full-payment">
							TITLE OF ACCOUNT TO BE PAID INTO:
						</label>
						<div className="input-holder company__input-holder">
							<input
								required
								type="text"
								id="full-amount-provision"
								name="full-amount-provision"
								placeholder="Input account title"
								onChange={(e) => setAccountTitle(e.target.value)}
							/>
						</div>
						<label htmlFor="full-amount-provision" className="full-payment">
							BANK NAME:
						</label>
						<div className="input-holder company__input-holder">
							<input
								required
								type="text"
								id="full-amount-provision"
								name="full-amount-provision"
								placeholder="Input bank name"
								onChange={(e) => setBankName(e.target.value)}
							/>
						</div>
						<label htmlFor="full-amount-provision" className="full-payment">
							BANK ACCOUNT NUMBER:
						</label>
						<div className="input-holder company__input-holder">
							<input
								required
								type="text"
								id="full-amount-provision"
								name="full-amount-provision"
								placeholder="Input account number"
								onChange={(e) => setAccountNum(e.target.value)}
							/>
						</div>
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="secondary"
						style={{ backgroundColor: "#901919", color: "#ffffff" }}
						onClick={handleClose}
					>
						Submit and Continue
					</Button>
				</Modal.Footer>
			</Modal>
			{submitting && <Preloader text={"Submiting"} />}
		</div>
	);
};

export default Initiator;
